import React, { useState } from 'react';
import { m, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { faqs } from '../../data/faq';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-54" data-mp="2z2fff6rkqyli">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-55" data-mp="2z5bfp1qw9zd4">
        <div className="text-center" data-id="element-56" data-mp="3mtum1bqdw22k">
          <SectionTag icon="❓" data-id="element-57" data-mp="3muw7891464y0">Resolvemos tus dudas</SectionTag>
        </div>

        <div className="mt-8 space-y-3" data-id="element-58" data-mp="3rrcy3azp6xes">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-white/10 bg-bg-secondary" data-id="element-59" data-mp="3i1tdo0wc6vht" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-lime" aria-expanded={isOpen} data-id="element-60" data-mp="9lrh5lal5ylc">
                  <span className="font-heading text-sm font-semibold text-white sm:text-base" data-id="element-61" data-mp="1vsezl3isxw9h">{faq.q}</span>
                  <ChevronDownIcon size={18} className={`flex-shrink-0 text-lime transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-62" data-mp="2ahl4970eseor" />
                </button>
                <AnimatePresence initial={false} data-id="element-63" data-mp="2eimuwzg9fif4">
                  {isOpen && <m.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-64" data-mp="2tfdv3axrcy5s">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-muted" data-id="element-65" data-mp="u29w9k134v4l">{faq.a}</p>
                    </m.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}